import { useState } from "react";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useWorkspace } from "@/context/WorkspaceContext";
import { Loading, ErrorState } from "@/components/common";
import { LogoMark } from "@/components/brand/Logo";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell({ children }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("cq_sb") === "1");
  const [mobileOpen, setMobileOpen] = useState(false);
  const { current, isLoading, error, reloadWorkspaces } = useWorkspace();
  const toggle = () => { localStorage.setItem("cq_sb", collapsed ? "0" : "1"); setCollapsed(!collapsed); };

  return (
    <div className="min-h-screen bg-[#050816] flex">
      <div className="hidden lg:block sticky top-0 h-screen shrink-0">
        <Sidebar collapsed={collapsed} onToggle={toggle} />
      </div>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-[270px] bg-[#050816] border-[#243153]">
          <Sidebar collapsed={false} onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onOpenMenu={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 sm:px-8 lg:px-10 py-8 max-w-[1440px] w-full mx-auto" data-testid="app-main">
          {isLoading ? <div className="py-24 flex flex-col items-center gap-4"><LogoMark size={56} className="animate-pulse" /><Loading label="Loading workspace" /></div> : error ? <ErrorState message="Could not load workspaces." onRetry={reloadWorkspaces} /> : current ? children : <Loading />}
        </main>
      </div>
    </div>
  );
}
